export default __webpack_public_path__ + "static/media/survey-body.d891f448.png";